function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_3115",
  "data-name": "Group 3115",
  transform: "translate(22706 -7545)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2846",
  "data-name": "Group 2846",
  transform: "translate(-22708 7543.098)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_23",
  "data-name": "Ellipse 23",
  cx: 16,
  cy: 16,
  r: 16,
  transform: "translate(2 1.902)",
  fill: "rgba(161,164,172,0.2)"
})), /*#__PURE__*/React.createElement("path", {
  id: "person_filled_FILL1_wght400_GRAD0_opsz48",
  d: "M15.6,16.075a3.417,3.417,0,0,1-3.562-3.562A3.417,3.417,0,0,1,15.6,8.95a3.417,3.417,0,0,1,3.562,3.562A3.417,3.417,0,0,1,15.6,16.075ZM9.425,23.7A1.419,1.419,0,0,1,8,22.273v-.807a2.614,2.614,0,0,1,.451-1.544,2.9,2.9,0,0,1,1.164-.974,17.851,17.851,0,0,1,3.052-1.069,12.337,12.337,0,0,1,2.933-.356,11.818,11.818,0,0,1,2.921.368,20.231,20.231,0,0,1,3.04,1.057,2.863,2.863,0,0,1,1.187.974,2.614,2.614,0,0,1,.451,1.544v.807A1.419,1.419,0,0,1,21.774,23.7Z",
  transform: "translate(-22705.6 7544.201)",
  fill: "#cc96f1"
}));

var SvgStudentAvatar = function SvgStudentAvatar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStudentAvatar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/student-avatar.d161a95d.svg";
export { ForwardRef as ReactComponent };